import { IgLoading } from "@intelligems/ig-theme/IgLoading";
import { Stack, useTheme } from "@mui/material";

export const PageLoading = () => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        position: "absolute",
        inset: 0,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.igPrimitives.gray[50],
      }}
    >
      <IgLoading />
    </Stack>
  );
};
